export default __webpack_public_path__ + "static/edit-description-fa753507746cbb87ab4eac369ef8a4f1.png";